import { motion } from "framer-motion";
import { IMAGES } from "@/config";

const CHAPTERS = [
  {
    n: "01",
    title: "Zuverlässig",
    text: "Termine sind bei uns kein Zufall. Wir kommunizieren klar, halten Zusagen ein und behandeln jedes Fahrzeug so, als wäre es unser eigenes.",
  },
  {
    n: "02",
    title: "Sauber",
    text: "Sorgfalt bis ins Detail — von der gründlichen Reinigung bis zur werterhaltenden Pflege. Ergebnisse, die man sieht und fühlt.",
  },
  {
    n: "03",
    title: "Einsatzbereit",
    text: "Kurzfristig, flexibel und deutschlandweit. Wenn Sie uns brauchen, sind wir bereit — für einzelne Fahrten oder laufende Aufträge.",
  },
];

const reveal = {
  hidden: { y: 40, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export const Manifesto = () => {
  return (
    <section
      id="ueber-uns"
      data-testid="manifesto-section"
      className="relative overflow-hidden py-24 lg:py-32"
    >
      <img
        src={IMAGES.texture}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover opacity-[0.08]"
      />
      <div className="absolute inset-0 bg-[#050505]/80" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mb-16 max-w-2xl"
        >
          <div className="mb-4 flex items-center gap-3">
            <span className="h-px w-10 bg-[#0052ff]" />
            <span className="text-xs uppercase tracking-[0.35em] text-[#94a3b8]">
              Über uns
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
            Drei Werte. Ein Versprechen.
          </h2>
        </motion.div>

        <div className="grid gap-px border-t border-white/10">
          {CHAPTERS.map((c) => (
            <motion.div
              key={c.n}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              data-testid={`manifesto-chapter-${c.n}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 border-b border-white/10 py-12"
            >
              <span className="md:col-span-3 font-display text-6xl md:text-8xl font-black leading-none text-transparent [-webkit-text-stroke:1px_rgba(148,163,184,0.4)] transition-all duration-500 group-hover:[-webkit-text-stroke:1px_rgba(0,82,255,0.9)]">
                {c.n}
              </span>
              <h3 className="md:col-span-3 font-display text-3xl font-bold text-white">
                {c.title}
              </h3>
              <p className="md:col-span-6 text-base text-[#94a3b8] leading-relaxed max-w-xl">
                {c.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
